import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import Button from '../Button';
import {COLOR} from '@/utils/constants/colors';
import {SIZE} from '@/utils/constants/globalStyle';

/**
 * Reusable back navigation control: tertiary Button with chevron_left.
 * Always returns to the previous history entry. beforeBack may persist
 * the current step; it cannot choose a route or a step index.
 */
const BackButton = ({
  id,
  className = 'mb-5',
  size = SIZE.MEDIUM,
  beforeBack,
  disabled = false
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    beforeBack?.();
    navigate(-1);
  };

  return (
    <Button
      id={id}
      handleButton={handleClick}
      uiSchema={{
        title: 'Back',
        variant: COLOR.TERTIARY,
        size,
        iconLeading: 'chevron_left',
        isDark: true,
        className,
        disabled
      }}
    />
  );
};

BackButton.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  beforeBack: PropTypes.func,
  disabled: PropTypes.bool
};

export default memo(BackButton);
